// Settings views
import Settings from '@/views/Settings.vue';
import Profile from '@/views/Profile.vue';

import Sites from '@/views/Settings/Sites.vue';
import Fees from '@/views/Settings/Fees.vue';
import TokenManagement from '@/views/Settings/TokenManagement.vue';
import PaymentMethods from '@/views/Settings/PaymentMethods.vue';
import SystemSettings from '@/views/Settings/SystemSettings.vue';
import MediaBuying from '@/views/Settings/MediaBuying.vue';
import SystemDomains from '@/views/Settings/SystemDomains.vue';
import PredefinedPage from '@/views/Settings/PredefinedPage.vue';
import OffersCountryGroups from '@/views/Settings/OffersCountryGroups.vue';
import SettingsCurrencies from '@/views/Settings/SettingsCurrencies.vue';

export default [
  {
    path: '/settings',
    component: Settings,
    meta: {
      requiresAuth: true,
      view: 'settings',
    },
    children: [
      {
        path: 'sites',
        component: Sites,
        name: 'settings.sites',
        meta: {
          view: 'sites',
        },
      },
      {
        path: 'fees',
        component: Fees,
        name: 'settings.fees',
        meta: {
          view: 'fees',
        },
      },
      {
        path: 'token-management',
        component: TokenManagement,
        name: 'settings.tokenManagement',
        meta: {
          view: 'tokenManagement',
        },
      },
      {
        path: 'payment-methods',
        component: PaymentMethods,
        name: 'settings.paymentMethods',
        meta: {
          view: 'paymentMethods',
        },
      },
      {
        path: 'system-settings',
        component: SystemSettings,
        name: 'settings.systemSettings',
        meta: {
          view: 'systemSettings',
        },
      },
      {
        path: 'media-buying',
        component: MediaBuying,
        name: 'settings.mediaBuying',
        meta: {
          view: 'mediaBuying',
        },
      },
      {
        path: 'system-domains',
        component: SystemDomains,
        name: 'settings.systemDomains',
        meta: {
          view: 'systemDomains',
        },
      },
      {
        path: 'predefined-page',
        component: PredefinedPage,
        name: 'settings.predefinedPage',
        meta: {
          view: 'predefinedPage',
        },
      },
      {
        path: 'offers-country-groups',
        component: OffersCountryGroups,
        name: 'settings.offersCountryGroups',
        meta: {
          view: 'offersCountryGroups',
        },
      },
      {
        path: 'currencies',
        component: SettingsCurrencies,
        name: 'settings.currencies',
        meta: {
          view: 'currencies',
        },
      },
      {
        path: '',
        name: 'settings.empty',
        redirect: 'sites',
      },
      {
        path: ':catchAll(.*)',
        name: 'settings.catch-all',
        redirect: 'sites',
      },
    ],
  },
  {
    path: '/profile',
    component: Profile,
    meta: {
      requiresAuth: true,
      view: 'profile',
    },
  },
];
